// src/components/visuals/ImpactGridVisual.tsx
import { motion } from 'framer-motion';

// A fixed set of points to represent impact initiatives on the grid.
// These are positioned within a 1000x500 viewport and will scale responsively.
const impactPoints = [
  { cx: 150, cy: 100, delay: 0.2, duration: 3.5 },
  { cx: 300, cy: 400, delay: 1.5, duration: 4.0 },
  { cx: 500, cy: 250, delay: 0.8, duration: 3.0 },
  { cx: 700, cy: 120, delay: 2.1, duration: 4.2 },
  { cx: 850, cy: 380, delay: 0.5, duration: 3.8 },
  { cx: 80,  cy: 350, delay: 2.8, duration: 3.2 },
  { cx: 920, cy: 80,  delay: 1.8, duration: 4.5 },
  { cx: 400, cy: 150, delay: 3.0, duration: 3.6 },
  { cx: 600, cy: 450, delay: 1.2, duration: 3.9 },
];

export const ImpactGridVisual = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1000 500" // A conceptual viewport
      preserveAspectRatio="xMidYMid slice"
      className="absolute inset-0"
    >
      <defs>
        {/* Define a reusable grid pattern */}
        <pattern
          id="impactGridPattern"
          width="50"
          height="50"
          patternUnits="userSpaceOnUse"
        >
          <path
            d="M 50 0 L 0 0 0 50"
            fill="none"
            stroke="#2e3c51" // A subtle grid color from your theme
            strokeWidth="1"
          />
        </pattern>
      </defs>

      {/* Fill the background with the grid pattern */}
      <rect width="100%" height="100%" fill="url(#impactGridPattern)" />

      {/* Render the pulsing impact nodes */}
      {impactPoints.map((point, i) => (
        <g key={i}>
          {/* The static center point of the node */}
          <circle
            cx={point.cx}
            cy={point.cy}
            r="3"
            fill="rgba(16, 185, 129, 0.5)" // Emerald-500 at 50% opacity
          />
          {/* The animating ripple */}
          <motion.circle
            cx={point.cx}
            cy={point.cy}
            r="80" // The maximum radius of the ripple
            fill="none"
            stroke="rgba(16, 185, 129, 0.8)" // Emerald-500
            strokeWidth="2"
            initial={{
              scale: 0,
              opacity: 1,
            }}
            animate={{
              scale: 1,
              opacity: 0,
            }}
            transition={{
              duration: point.duration,
              delay: point.delay,
              ease: "easeOut",
              repeat: Infinity,
              repeatType: 'loop',
            }}
          />
        </g>
      ))}
    </svg>
  );
};